import React from "react";

import { InputBase } from "@material-ui/core";

import { months } from "../../helpers/dateHelpers";

import { NumberFormatCustom } from "../../common/helpers";

import moment from "moment";

import styled from "styled-components";

export const getDateValues = (key) => {
  var [year, month, day] = key.split("-");

  if (!day) {
    var tmp = new Date(year, month, 0);

    day = tmp.getDate();
  }

  return {
    year: year.toString(),
    month: month.toString(),
    day: day.toString(),
  };
};

const getMonthName = (month) => {
  return months.find((e) => e.id === parseInt(month, 10)).value;
};

const Ellipses = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
`;

const getValueString = (val, showZero = true) => {
  return (
    <Ellipses title={"$" + val}>
      {val ? `$${val}` : showZero ? "$0" : ""}
    </Ellipses>
  );
};

const Render = (props) => {
  const { portfolio, actions } = props;

  const [selectedYear] = React.useState("all");

  var rows = [];

  portfolio.portfolioValues.forEach((cont) => {
    var t = getDateValues(cont.key);
    rows.push({ ...cont, isPortfolioValue: true, ...t });
  });

  rows = rows.sort((a, b) => (a.key > b.key ? 1 : -1));

  var years = [];

  if (rows.length > 0) {
    const [yStart] = rows[0].key.split("-");
    const [yEnd] = rows[rows.length - 1].key.split("-");

    for (var i = yStart; i <= yEnd; i++) {
      years.push(i);
    }
  }

  if (selectedYear !== "all") {
    rows = rows.filter((e) => e.year.toString() === selectedYear.toString());
  }

  return (
    <div style={{ marginTop: -20 }}>
      {years.map((year, yearIndex) => (
        <div key={year}>
          <div style={{ fontSize: 20, margin: 10 }}>{year}</div>
          {rows
            .filter((e) => e.year.toString() === year.toString())
            .sort((a, b) => (a.key > b.key ? 1 : -1))
            .map((item, rowIndex) => (
              <div key={item.key}>
                <div
                  style={{
                    display: "flex",
                    border: "1px solid #b7b7b7",
                    marginBottom: -1,
                  }}
                >
                  <div
                    style={{ padding: 10, width: "100%", margin: "auto 10px" }}
                  >
                    {getMonthName(item.month)}
                  </div>
                  <div style={{ padding: 10, borderLeft: "1px solid #b7b7b7" }}>
                    <InputBase
                      title={
                        yearIndex === 0 && rowIndex === 0
                          ? "Starting Month is always $100"
                          : item.value
                            ? "$" + item.value
                            : "Portfolio Value Required"
                      }
                      value={
                        yearIndex === 0 && rowIndex === 0
                          ? "100"
                          : item.value
                            ? item.value
                            : ""
                      }
                      disabled={yearIndex === 0 && rowIndex === 0}
                      inputComponent={NumberFormatCustom}
                      inputProps={{
                        style: {
                          padding: 10,
                          backgroundColor:
                            !item.value && yearIndex + rowIndex > 0
                              ? "#fff2f2"
                              : "initial",
                          border:
                            !item.value && yearIndex + rowIndex > 0
                              ? "1px solid #ffbebe"
                              : "1px solid #c8c6e6",
                          borderRadius: 10,
                        },
                      }}
                      onChange={(event) => {
                        actions.setPortfolioItemValue(
                          props,
                          portfolio.portfolioNumber,
                          "value",
                          event.target.value,
                          item.key,
                        );
                      }}
                    />
                  </div>
                </div>
              </div>
            ))}
        </div>
      ))}
    </div>
  );
};

const Title = "Portfolio Values";

const getErrors = (props) => {
  const ret = [];

  const { portfolio } = props;

  if (
    portfolio.portfolioValues.filter((e, i) => i !== 0).find((e) => !e.value)
  ) {
    ret.push("All months must have a closing monthly value.");
  }

  if (portfolio.portfolioValues.length < 10) {
    ret.push("A minimum of 10 months are required for analysis.");
  }

  return ret;
};

const Description = () => {
  return (
    <div>
      <p>
        This is a listing of all months included in your portfolio analysis
        period. Each month requires a month end closing value.
      </p>
    </div>
  );
};

const Preview = (props) => {
  const { portfolio } = props;

  var rows = [];

  portfolio.contributions.forEach((cont) => {
    var t = getDateValues(cont.key);

    rows.push({ ...cont, ...t });
  });

  portfolio.fees.forEach((cont) => {
    var t = getDateValues(cont.key);

    var found = rows.find(
      (e) => e.year === t.year && e.month === t.month && e.day === t.day,
    );

    if (found) {
      found.feePaidToManager = cont.feePaidToManager;
    } else {
      rows.push({ ...cont, ...t });
    }
  });

  portfolio.portfolioValues.forEach((cont) => {
    var t = getDateValues(cont.key);

    var found = rows.find(
      (e) => e.year === t.year && e.month === t.month && e.day === t.day,
    );

    if (found) {
      found.value = cont.value;
      found.isPortfolioValue = true;
    } else {
      rows.push({
        ...cont,
        isPortfolioValue: true,
        ...t,
        key: `${t.year}-${t.month}-${t.day}`,
      });
    }
  });

  rows = rows.sort((a, b) => (a.key > b.key ? 1 : -1));

  return (
    <div>
      <div style={{ display: "flex" }}>
        <PreviewCell></PreviewCell>
        <PreviewCell></PreviewCell>
        <PreviewCell
          style={{
            width: 210,
            minWidth: 210,
            maxWidth: 210,
            textAlign: "center",
            fontWeight: "bold",
            borderLeft: "1px solid black",
          }}
        >
          Contributions
        </PreviewCell>
        <PreviewCell
          style={{
            width: 210,
            minWidth: 210,
            maxWidth: 210,
            textAlign: "center",
            fontWeight: "bold",
            borderLeft: "1px solid black",
          }}
        >
          Withdrawals
        </PreviewCell>
        <PreviewCell style={{ borderLeft: "1px solid black" }}></PreviewCell>
      </div>
      <div style={{ display: "flex", borderBottom: "1px solid black" }}>
        <PreviewCell>Date</PreviewCell>
        <PreviewCell>Month End</PreviewCell>
        <PreviewCell style={{ borderLeft: "1px solid black" }}>
          Cash
        </PreviewCell>
        <PreviewCell>Securities</PreviewCell>
        <PreviewCell style={{ borderLeft: "1px solid black" }}>
          Cash
        </PreviewCell>
        <PreviewCell>Securities</PreviewCell>
        <PreviewCell style={{ borderLeft: "1px solid black" }}>
          Manager Fees
        </PreviewCell>
      </div>
      {rows.map((row) => (
        <div key={row.key} style={{ display: "flex" }}>
          <PreviewCell>
            {moment(`${row.year}-${row.month}-${row.day}`).format(
              "MMM Do, YYYY",
            )}
          </PreviewCell>
          <PreviewCell
            style={{ fontWeight: row.isPortfolioValue ? "bold" : "" }}
          >
            {row.isPortfolioValue ? getValueString(row.value) : "--"}
          </PreviewCell>
          <PreviewCell style={{ borderLeft: "1px solid black" }}>
            {getValueString(row.contribution, false)}
          </PreviewCell>
          <PreviewCell
            style={{ borderLeft: "1px solid #d8d8d8", marginLeft: -1 }}
          >
            {getValueString(row.securitiesTransferred, false)}
          </PreviewCell>
          <PreviewCell style={{ borderLeft: "1px solid black" }}>
            {getValueString(row.cashWithdrawl, false)}
          </PreviewCell>
          <PreviewCell
            style={{ borderLeft: "1px solid #d8d8d8", marginLeft: -1 }}
          >
            {getValueString(row.securitiesWithdrawn, false)}
          </PreviewCell>
          <PreviewCell style={{ borderLeft: "1px solid black" }}>
            {getValueString(row.feePaidToManager, false)}
          </PreviewCell>
        </div>
      ))}

      {/* {groupBy(rows, 'year').sort((a, b) => valueSort(a, b, 'key')).map((year, yI) => <div key={year.key} style={{ width: 'fit-content' }}>
            {groupBy(year.items, 'month').sort((a, b) => valueSort(a, b, 'key')).map((month, mI) => <div key={month.key} style={{ marginBottom: 20 }}>
                
            </div>)}
        </div>)} */}
    </div>
  );
};

const PreviewCell = styled.div`
  width: 100px;
  min-width: 100px;
  max-width: 100px;
  padding: 5px;
  font-size: 14px;
  text-align: center;
`;

function isComplete(props) {
  const errors = getErrors(props);

  return errors.length === 0;
}

export default Render;

export { isComplete, Render, Title, Description, Preview, getErrors };



// WEBPACK FOOTER //
// ./src/portfolioEntryWizard/components/PortfolioValuesNew.js